import type { MenuProps } from '@mui/material';
import type { MouseEvent } from 'react';

/**
 * Menu props for a Select inside an operation panel. The menu is portaled
 * out of the panel, so it stops its own clicks the way the panel does. It
 * opens below the field from the field's left edge, and it caps its height
 * at `maxHeight` px.
 */
export function selectMenuProps(maxHeight: number): Partial<MenuProps> {
    return {
        disablePortal: false,
        disableScrollLock: true,
        anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
        transformOrigin: { vertical: 'top', horizontal: 'left' },
        onClick: (e: MouseEvent) => e.stopPropagation(),
        onMouseDown: (e: MouseEvent) => e.stopPropagation(),
        slotProps: { paper: { sx: { maxHeight, zIndex: 1500 } } },
    };
}

export const menuProps = selectMenuProps(200);
